
import HeroBanner from '../components/guide/HeroBanner'
import { Heading } from '../components/guide/Heading'
import PrincipleCard from '../components/guide/PrincipleCard'
import CtaBanner from '../components/guide/CtaBanner'
import BannerImg from '../assets/images/banner/guide_banner_1.png';

export default function PrinciplesPage() {
    return (
        <div>
            <HeroBanner image={BannerImg} message="미분양 브랜딩부터, 현장 완판까지!" />

            <div className="space-y-4">
                <Heading className={'hidden md:block mt-[93px] mb-[96px]'} as="h1" size="h1">
                    분양의신 3원칙
                </Heading>

                <Heading as="p" size="subtitle" className="text-black font-[600]">
                    “광고는 보여주는 것이 아니라, 결과로 증명되어야 합니다.”
                </Heading>

                <Heading as="p" size="subtitle" className="text-black font-[400]">
                    우리는 프리미엄 콘텐츠, 올인원(All‑in‑one) 대행,
                    고객 최상이득 세 가지 핵심 원칙을 통해
                    고객의 성공을 보장합니다.
                </Heading>
            </div>

            {/* Cards */}
            <div className="my-[60px] md:my-[93px] grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                <PrincipleCard href={'/guide/principles/premium'} index="01" title="프리미엄 콘텐츠 & 성과 중심 광고 솔루션" />
                <PrincipleCard href={'/guide/principles/all-in-one'} index="02" title="올인원(All‑in‑One) 대행 시스템" />
                <PrincipleCard href={'/guide/principles/profit'} index="03" title="고객이 실제로 돈을 벌게 만드는 광고" fullSpan />
            </div>

            <CtaBanner
                message="고객님의 성공이 곧 우리의 성공입니다."
                buttonText="광고문의 바로가기 →"
                href="https://분양의신.net/contact"
            />
        </div>
    )
}
